import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InnForm from "@/components/ds/form/Form.vue";
import { PropType } from "vue";
import { Company } from "@/types";



export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyTertiary',
  props: {
    company: {
        type: Object as PropType<Company>,
        required: true,
    },
},
  setup(__props) {



const config = {
    sections: [
        {
            items: [
                {
                    type: "checkbox",
                    key: "usesMail",
                    label: "Gebruikt mail",
                },
                {
                    type: "checkbox",
                    key: "usesGoogleDrive",
                    label: "Gebruikt Google Drive",
                },
                {
                    type: "checkbox",
                    key: "usesAcumulus",
                    label: "Gebruikt Acumulus",
                },
            ],
        },
    ],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnForm, {
    value: __props.company,
    config: config
  }, null, 8, ["value"]))
}
}

})